import { combineReducers } from '@reduxjs/toolkit'

import { sidebarReducer } from './sidebar'
import userSlice from './user'

export default combineReducers({
	sidebar: sidebarReducer,
	user: userSlice.reducer
})
